module.exports = __webpack_public_path__ + "static/img/pic_30.57788d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_30.png
// module id = 9RLX
// module chunks = 1